import React, { useEffect } from "react";
import styles from "./InvoiceTemplates.module.css";
import { Button } from "@mui/material";
import InvoiceTemplateRow from "@_components/InvoiceTemplateRow/InvoiceTemplateRow";
import InvoiceTemplateEditor from "@_components/InvoiceTemplateEditor/invoiceTemplateEditor";
import { invoiceTemplateActions } from "@_actions/invoiceTemplate.actions";
import { useDispatch, useSelector } from "react-redux";
import { catchError } from "@_utils/helpers";
import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";
import Scrollbar from "react-perfect-scrollbar-z";
import "scrollbar.css";
import { sidebarActions } from "@_actions/sidebar.actions";
import { sidebarConstants } from "@_constants/sidebar.constants";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

function InvoiceTemplates() {
  const dispatch = useDispatch();
  const { snackbarProps, showSnackbarSuccess, showSnackbarError } = useSnackbar();
  const invoiceTemplateReducer = useSelector(
    (state) => state.invoiceTemplateReducer,
  );

  const history = useHistory();
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  useEffect(() => {
    dispatch(invoiceTemplateActions.getInvoiceTemplates());
    dispatch(sidebarActions.updateStatus(sidebarConstants.INVOICE_TEMPLATES));
    return () => {
      dispatch(invoiceTemplateActions.selectInvoiceTemplate(null));
      dispatch(invoiceTemplateActions.addInvoiceTemplateState(false));
    };
  }, [dispatch]);

  useEffect(() => {
    if (invoiceTemplateReducer.status.INVOICE_TEMPLATES_GET === "success") {
      if (pathParts.length === 3 && pathParts[1] === "invoices") {
        if (
          !invoiceTemplateReducer.templates.some((x) => x.id === pathParts[2])
        ) {
          history.push("/page_not_found");
        } else {
          dispatch(invoiceTemplateActions.addInvoiceTemplateState(false));
          dispatch(invoiceTemplateActions.selectInvoiceTemplate(pathParts[2]));
        }
      }
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATES_GET"),
      );
    } else if (
      catchError(invoiceTemplateReducer.status.INVOICE_TEMPLATES_GET)
    ) {
      showSnackbarError(invoiceTemplateReducer.status.INVOICE_TEMPLATES_GET);
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATES_GET"),
      );
    }
    // eslint-disable-next-line
  }, [
    dispatch,
    history,
    invoiceTemplateReducer.status.INVOICE_TEMPLATES_GET,
    showSnackbarError,
  ]);

  const handleAddInvoiceTemplate = () => {
    history.push("/templates/invoices");
    dispatch(invoiceTemplateActions.addInvoiceTemplateState(true));
    dispatch(invoiceTemplateActions.selectInvoiceTemplate(null));
  };

  useEffect(() => {
    if (
      invoiceTemplateReducer.status.INVOICE_TEMPLATE_CREATE === "success" ||
      invoiceTemplateReducer.status.INVOICE_TEMPLATE_UPDATE === "success"
    ) {
      showSnackbarSuccess("Success!");
      dispatch(invoiceTemplateActions.getInvoiceTemplates());
      dispatch(invoiceTemplateActions.addInvoiceTemplateState(false));
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATE_CREATE"),
      );
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATE_UPDATE"),
      );
    } else if (
      catchError(invoiceTemplateReducer.status.INVOICE_TEMPLATE_CREATE)
    ) {
      showSnackbarError(invoiceTemplateReducer.status.INVOICE_TEMPLATE_CREATE);
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATE_CREATE"),
      );
    } else if (
      catchError(invoiceTemplateReducer.status.INVOICE_TEMPLATE_UPDATE)
    ) {
      showSnackbarError(invoiceTemplateReducer.status.INVOICE_TEMPLATE_UPDATE);
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATE_UPDATE"),
      );
    } else return;
  }, [
    dispatch,
    invoiceTemplateReducer.status.INVOICE_TEMPLATE_CREATE,
    invoiceTemplateReducer.status.INVOICE_TEMPLATE_UPDATE,
    showSnackbarError,
    showSnackbarSuccess,
  ]);

  useEffect(() => {
    if (catchError(invoiceTemplateReducer.status.INVOICE_TEMPLATE_PREVIEW)) {
      showSnackbarError(invoiceTemplateReducer.status.INVOICE_TEMPLATE_PREVIEW);
      dispatch(
        invoiceTemplateActions.clearStatusMessage("INVOICE_TEMPLATE_PREVIEW"),
      );
    } else return;
  }, [
    dispatch,
    invoiceTemplateReducer.status.INVOICE_TEMPLATE_PREVIEW,
    showSnackbarError,
  ]);

  return (
    <div className={styles.root}>
      <AppSnackbar {...snackbarProps} />
      <div className={styles.template_list_container}>
        <Scrollbar maxHeight="calc(100vh - 140px)" height="calc(100vh - 140px)">
          <div className={styles.add_template_container}>
            <Button
              style={{ backgroundColor: "white" }}
              onClick={handleAddInvoiceTemplate}
              variant="outlined"
            >
              Add invoice Template
            </Button>
          </div>
          {invoiceTemplateReducer.templates &&
            invoiceTemplateReducer.templates.map((template, index) => {
              return (
                <InvoiceTemplateRow
                  data={template}
                  key={template.id}
                  index={index}
                />
              );
            })}
        </Scrollbar>
      </div>
      <Scrollbar maxHeight="calc(100vh - 141px)">
        <div className={styles.template_container}>
          {(invoiceTemplateReducer.selected_template &&
            Object.keys(invoiceTemplateReducer.selected_template).length !==
              0) ||
          invoiceTemplateReducer.add_template ? (
            <InvoiceTemplateEditor
              data={
                invoiceTemplateReducer.add_template === true
                  ? {}
                  : typeof invoiceTemplateReducer.add_template === "string"
                    ? {
                        ...invoiceTemplateReducer.templates.find(
                          (x) => x.id === invoiceTemplateReducer.add_template,
                        ),
                        id: undefined,
                        name:
                          invoiceTemplateReducer.templates.find(
                            (x) => x.id === invoiceTemplateReducer.add_template,
                          ).name + " - Copy",
                      }
                    : invoiceTemplateReducer.templates.find(
                        (x) =>
                          x.id === invoiceTemplateReducer.selected_template,
                      )
              }
              // we need to change the key when add_template is true (this is when new invoice template is clicked)
              // without random key it will not re-rendered when you copy first and then click new template, because key is null
              // in both cases
              key={
                invoiceTemplateReducer.add_template === true
                  ? Math.random().toString
                  : invoiceTemplateReducer.selected_template
              }
            />
          ) : null}
        </div>{" "}
      </Scrollbar>
    </div>
  );
}
export default InvoiceTemplates;
